import React from 'react';
import { useSelector } from 'react-redux';
import { getShowConfirmationPage } from '../../../selectors/tools';
import DTSendMacroAndCancelSubscriptionWithCurrentOrderNode from '../NodeGroups/DTCopyTextSendMacro/CancelSubscription/DTSendMacroAndCancelSubscriptionWithCurrentOrderNode/DTSendMacroAndCancelSubscriptionWithCurrentOrderNode';

const SendMacroAndCancelSubscriptionWithCurrentOrder = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTSendMacroAndCancelSubscriptionWithCurrentOrderNode
      showConfirmation={showConfirmationPage}
      message={'The subscription has been canceled.'}
    />
  );
};

export default SendMacroAndCancelSubscriptionWithCurrentOrder;
